<template>
  <div class="page">
    <announcement/>
    <balanceWithdraw></balanceWithdraw>
    <div class="workbench">
    <van-cell-group v-if="hasRole('clerk')">
      <div slot="title" class="module-header" style="position: relative;">
        <div class="flex align-center justify-between">
          <div>
            <span>店员</span>
            <img src="/static/images/37/love.png" style="width: 10px;position: relative;top: -8px">
          </div>
          <div v-if="clerk != null" class="flex align-center">
            <template v-if="$hasFeature('auto_online')">
              <span v-if="clerkIsAutoOnline" class="switch-name">自动在线</span>
              <span v-else-if="!clerkIsAutoOnline" class="switch-name">手动在线</span>
              <van-switch v-model="clerkIsAutoOnline" active-color="#36A5B6" class="margin-left-sm margin-right-sm"
                          inactive-color="var(--grey)"
                          size="24" @input="(input)=>updateClerkIsAutoOnline(input)"/>
            </template>
            <span v-if="clerk.status == 1" class="switch-name">在线</span>
            <span v-else-if="clerk.status == 2" class="switch-name">离线</span>
            <van-switch :active-value="1" :inactive-value="2" :loading="updateClerkStatusLoading" :value="clerk.status"
                        active-color="#36A5B6" class="margin-left-sm" inactive-color="var(--grey)" size="24"
                        @input="(input)=>updateStatus(input,'clerk')"/>

          </div>
        </div>
        <div v-if=" $ClerkPermission.modifiableClerkAttr.includes('randomOrderSwitch')" class="flex justify-end align-center margin-top-sm">
          <span class="switch-name flex align-center">
           <question-mark class="margin-right-xs" msg="在线且随机单开启时，才会接收到随机单通知"/>
            随机单
          </span>
          <van-switch class="margin-left-sm" size="24" active-color="#36A5B6" inactive-color="var(--grey)" :value="clerk.randomOrderSwitch" @input="(input)=>updateRandomOrderSwitch(input)" />
        </div>
      </div>
      <div v-if="itemSwitchList.length > 0" class="item-switch">
          <van-row type="flex" justify="space-between">
              <van-col v-for="(switchItem, index) of itemSwitchList" :key="index" class="switch-wrap">
                <div class="item-name switch-name">{{switchItem.name}}</div>
                  <van-switch :value="clerkItemSwitchIds.indexOf(switchItem.id) != -1" active-color="#36A5B6" inactive-color="var(--grey)" size="18" @change="updateItemSwitch(switchItem.id)" />
              </van-col>
          </van-row>
      </div>
      <van-row class="grid" type="flex">
        <van-col span="8" v-if="$ClerkAccess.includes('manual')">
          <router-link class="item" to="/article/list?type=2">
            <img src="/static/images/37/manual.png" height="25px">
            <div class="text">手册</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$ClerkAccess.includes('order')">
          <router-link class="item  " to="/clerk/order/list">
            <img src="/static/images/37/order.png" height="25px">
            <div class="text">订单</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$ClerkAccess.includes('random')">
          <router-link class="item  " to="/clerk/random">
            <img src="/static/images/37/file.png" height="25px">
            <div class="text">抢单大厅</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$ClerkAccess.includes('wages')">
          <router-link class="item  " to="/clerk/wages">
            <img src="/static/images/37/wages.png" height="25px">
            <div class="text">工资</div>
          </router-link>
        </van-col>
<!--        <van-col span="8" >-->
<!--          <router-link class="item  " to="/clerk/ranking">-->
<!--            <img src="/static/images/37/trophy.png" height="25px">-->
<!--            <div class="text">排名</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
        <van-col span="8" v-if="$ClerkAccess.includes('ranking-list')">
          <router-link class="item  " to="/clerk/ranking-list">
            <img src="/static/images/37/ranking.png" height="25px">
            <div class="text">排行榜</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$ClerkAccess.includes('info')">
          <router-link class="item  " to="/clerk/info">
            <img src="/static/images/37/data.png" height="25px">
            <div class="text">我的资料</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$ClerkAccess.includes('grade')">
          <router-link class="item  " to="/clerk/grade">
            <img src="/static/images/37/grade.png" height="25px">
            <div class="text">我的等级</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('post_list') && $ClerkAccess.includes('post-list')">
          <router-link class="item  " to="/clerk/post/list">
            <van-icon color="#36A5B6" name="chat-o" size="25px"/>
            <div class="text">发布动态</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('auto_online') && $ClerkAccess.includes('auto-online')">
          <router-link class="item" to="/clerk/auto/online">
            <van-icon color="#36A5B6" name="underway-o" size="25px"/>
            <div class="text">自动在线</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('gift_wall') && $ClerkAccess.includes('gift')" span="8">
          <router-link class="item" to="/clerk/gift">
            <van-icon color="#36A5B6" name="send-gift-o" size="25px"/>
            <div class="text">我的礼物</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$ClerkAccess.includes('my-performance')">
          <router-link class="item" to="/clerk/performance">
            <van-icon color="#76c3ce" name="bar-chart-o" size="25px"/>
            <div class="text">我的业绩</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$ClerkAccess.includes('item-price')">
          <router-link class="item" to="/clerk/item-price">
            <van-icon color="#76c3ce" name="bill-o" size="25px"/>
            <div class="text">服务价格</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('chat') && $ClerkAccess.includes('chat')">
          <router-link class="item" to="/clerk/chat/roomList">
            <van-icon color="#76c3ce" name="76c3ce-o" size="25px"/>
            <div class="text">聊天</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('clerk_pk')">
          <router-link class="item" to="/clerk/clerk-pk">
            <i class="free free-pk_line"  style="font-size: 30px;color: #76c3ce;"/>
            <div class="text">店员PK</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>
    <van-cell-group v-else>
      <van-row class="grid">
        <van-col span="24">
          <router-link class="item  " to="/clerk/add">
            <van-icon name="manager-o" size="30px" color="#4bc72e" />
            <div class="text">上传店员资料</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-cell-group v-if="hasRole('kf')">
      <div slot="title" style="position: relative">
        客服<img src="/static/images/37/love.png" style="width: 10px;position: relative;top: -8px">
        <div v-if="kf != null" class="clerk-status">
          <span v-if="kf.status == 1" class="switch-name">在线</span>
          <span v-else-if="kf.status == 2" class="switch-name">离线</span>
          <van-switch :active-value="1" :inactive-value="2" :loading="updateKfStatusLoading" :value="kf.status"
                      active-color="#36A5B6" class="margin-left-sm" inactive-color="var(--grey)" size="24"
                      @input="(input)=>{updateStatus(input,'kf')}"/>
        </div>
      </div>
      <van-row type="flex" class="grid">
        <van-col span="8" v-if="$KfAccess.includes('manual')">
          <router-link class="item" to="/article/list?type=3">
            <img src="/static/images/37/manual.png" height="25px">
            <div class="text">客服手册</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$KfAccess.includes('order')">
            <router-link class="item  " to="/kf/order/list">
              <img src="/static/images/37/order.png" height="25px">
                <div class="text">订单</div>
            </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('order-rate')" span="8">
          <router-link class="item" to="/kf/order/rate-list">
            <van-icon color="#76c3ce" name="completed" size="25px"/>
            <div class="text">订单评价</div>
          </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('order-complain')" span="8">
          <router-link class="item" to="/kf/order/complain-list">
            <van-icon color="#76c3ce" name="failure" size="25px"/>
            <div class="text">订单投诉</div>
          </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('continued-apply')" span="8">
          <router-link class="item" to="/kf/order/continued-apply">
            <van-icon color="#76c3ce" name="completed" size="25px"/>
            <div class="text">续单审核</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('out_order') && $KfAccess.includes('out-order')">
          <router-link class="item " to="/kf/order/out-order-list">
            <img src="/static/images/37/order.png" height="25px">
            <div class="text">外部订单</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$KfAccess.includes('wages')">
          <router-link class="item  " to="/kf/wages">
            <img src="/static/images/37/wages.png" height="25px">
            <div class="text">工资</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$KfAccess.includes('user-manage')">
          <router-link class="item" to="/kf/user/user-list">
            <van-icon color="#76c3ce" name="manager-o" size="30px"/>
            <div class="text">用户管理</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-cell-group v-if="hasRole('leader')">
      <div slot="title" style="position: relative">
        组长<img src="/static/images/37/love.png" style="width: 10px;position: relative;top: -8px">
        <div v-if="leader != null" class="clerk-status">
          <span v-if="leader.status == 1" class="switch-name">在线</span>
          <span v-else-if="leader.status == 2" class="switch-name">离线</span>
          <van-switch :active-value="1" :inactive-value="2" :loading="updateLeaderStatusLoading" :value="leader.status"
                      active-color="#36A5B6" class="margin-left-sm" inactive-color="var(--grey)" size="24"
                      @input="(input)=>{updateStatus(input,'leader')}"/>
        </div>
      </div>
      <van-row type="flex" class="grid">
        <van-col span="8" v-if="$LeaderAccess.includes('manual')">
          <router-link class="item" to="/article/list?type=4">
            <img src="/static/images/37/manual.png" height="25px">
            <div class="text">组长手册</div>
          </router-link>
        </van-col>
        <van-col  v-if="$LeaderAccess.includes('order')" span="8">
          <router-link class="item" to="/leader/order/list">
            <img src="/static/images/37/order.png" height="25px">
            <div class="text">订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('order-rate')" span="8">
          <router-link class="item" to="/leader/order/rate-list">
            <van-icon color="#76c3ce" name="completed" size="25px"/>
            <div class="text">订单评价</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('order-complain')" span="8">
          <router-link class="item" to="/leader/order/complain-list">
            <van-icon color="#76c3ce" name="failure" size="25px"/>
            <div class="text">订单投诉</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$LeaderAccess.includes('wages')">
          <router-link class="item  " to="/leader/wages">
            <img src="/static/images/37/wages.png" height="25px">
            <div class="text">工资</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('continued-apply')" span="8">
          <router-link class="item" to="/leader/continued-apply">
            <van-icon color="#76c3ce" name="completed" size="25px"/>
            <div class="text">续单审核</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$LeaderAccess.includes('clerk-apply-list')">
          <router-link class="item  " to="/leader/clerk-apply-list">
            <img src="/static/images/37/personal.png" height="25px">
            <div class="text">新店员申请</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$LeaderAccess.includes('clerk-check-list')">
          <router-link class="item" to="/leader/clerk-check/clerk-check-list">
            <van-icon color="#76c3ce" name="friends-o" size="25px"/>
            <div class="text">店员资料审核</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('post_list') && $LeaderAccess.includes('clerk-post-check-list')">
          <router-link class="item" to="/leader/clerk-post-check-list">
            <van-icon color="#76c3ce" name="chat-o" size="25px"/>
            <div class="text">动态审核</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$LeaderAccess.includes('clerk-manage')">
          <router-link class="item" to="/leader/clerk-manage">
            <van-icon color="#76c3ce" name="manager-o" size="30px"/>
            <div class="text">店员管理</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$LeaderAccess.includes('clerk-performance')">
          <router-link class="item" to="/leader/clerk-performance">
            <van-icon color="#76c3ce" name="bar-chart-o" size="25px"/>
            <div class="text">店员业绩</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-cell-group v-if="hasRole('admin')">
      <div slot="title">
        管理员<img src="/static/images/37/love.png" style="width: 10px;position: relative;top: -8px">
      </div>
      <van-row type="flex" class="grid">
        <van-col span="8" v-if="$hasRole('super_admin') || $AdminAccess.includes('order')">
          <router-link class="item  " to="/admin/order/list">
            <img src="/static/images/37/order.png" height="25px">
            <div class="text">订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('order-rate')" span="8">
          <router-link class="item" to="/admin/order/rate-list">
            <van-icon color="#76c3ce" name="completed" size="25px"/>
            <div class="text">订单评价</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('order-complain')" span="8">
          <router-link class="item" to="/admin/order/complain-list">
            <van-icon color="#76c3ce" name="failure" size="25px"/>
            <div class="text">订单投诉</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasRole('super_admin') || $AdminAccess.includes('leader-wages')">
          <router-link class="item  " to="/admin/leader-wages">
            <img src="/static/images/37/wages.png" height="25px">
            <div class="text">组长工资</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasRole('super_admin') || $AdminAccess.includes('clerk-performance')">
          <router-link class="item" to="/admin/clerk-performance">
            <van-icon color="#76c3ce" name="bar-chart-o" size="25px"/>
            <div class="text">店员业绩</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasRole('super_admin') || $AdminAccess.includes('continued-apply')">
          <router-link class="item" to="/admin/order/continued-apply">
            <van-icon color="#76c3ce" name="completed" size="25px"/>
            <div class="text">续单审核</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasFeature('post_list') && ($hasRole('super_admin') || $AdminAccess.includes('post-list'))">
          <router-link class="item  " to="/admin/post-list">
            <van-icon color="#36A5B6" name="chat-o" size="25px"/>
            <div class="text">动态管理</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasRole('super_admin') || $AdminAccess.includes('check-list')">
          <router-link class="item" to="/admin/check-list">
            <van-icon color="#76c3ce" name="friends-o" size="25px"/>
            <div class="text">店员资料审核</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasRole('super_admin') || $AdminAccess.includes('clerk-manage')">
          <router-link class="item" to="/admin/clerk-manage">
            <van-icon color="#76c3ce" name="manager-o" size="30px"/>
            <div class="text">店员管理</div>
          </router-link>
        </van-col>
        <van-col span="8" v-if="$hasRole('super_admin') || $AdminAccess.includes('user-manage')">
          <router-link class="item" to="/admin/user/user-list">
            <van-icon color="#76c3ce" name="manager-o" size="30px"/>
            <div class="text">用户管理</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('tech_support_visitor') && $hasRole('super_admin')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/tech-support-visitor-list">
            <van-icon color="var(--primary-color)" name="manager-o" size="30px"/>
            <div class="text">开店咨询</div>
          </router-link>
        </van-col>
        <van-col v-if="$store.state.shop.platform == $store.state.ShopPlatformEnum.DINGTALK.value" span="8">
          <router-link class="item  " to="/leader/get_userid">
            <van-icon name="more-o" size="30px" color="#4bc72e" />
            <div class="text">获取用户ID</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>
    </div>

    <van-row v-if="clerkWarning" type="flex" justify="center" align="center" :style="'margin-top:10rem;'">
      <van-col span="8"  :style="'text-align:center'">
        <van-icon name="warning" color="lightblue" size="8rem" />
      </van-col>
      <van-col span="24" align="center" :style="'margin-top:10px;font-weight:bold;text-align:center'">
        <div>您已被下架，没有权限访问</div>
      </van-col>
    </van-row>

    <van-row v-if="isResigned" type="flex" justify="center" align="center" :style="'margin-top:10rem;'">
      <van-col span="8"  :style="'text-align:center'">
        <van-icon name="warning" color="lightblue" size="8rem" />
      </van-col>
      <van-col span="24" align="center" :style="'margin-top:10px;font-weight:bold;text-align:center'">
        <div>您已离职，需要复职请联系店铺管理员。</div>
      </van-col>
    </van-row>

    <div class="margin-top-lg text-center">
      <router-link to="/clear-storage">清理缓存</router-link>
    </div>

    <foot></foot>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Row, Col, Icon, CellGroup, Cell, Switch, Dialog, Toast } from 'vant';
  import { getUserRoles } from '@/api/index'
  import {
    getClerk,
    updateClerkStatus,
    getItemSwitchList,
    updateItemSwitch,
    updateClerkAutoOnlineStatus, updateRandomOrderSwitch
  } from '@/api/clerk/clerk'
  import foot from '@/views/foot';
  import {getKf, updateKfStatus} from "@/api/kf/kf";
  import {getLeader, updateLeaderStatus} from "@/api/leader/leader";
  import {getClerkSetting} from "@/api/shop";
  import QuestionMark from "@/views/question-mark";
  import Announcement from "@/views/announcement";
  import balanceWithdraw from "@/components/common/balance-withdraw";

  Vue.use(Row)
      .use(Col)
      .use(Icon)
      .use(CellGroup)
      .use(Cell)
      .use(Switch)
      .use(Dialog)
      .use(Toast)

  export default {
    name: 'index',
    components: {
      Announcement,
      QuestionMark,
      balanceWithdraw,
      foot
    },
    data () {
      return {
        kf: null,
        leader: null,
        roles: null,
        clerk: null,
        clerkIsAutoOnline: false,
        updateClerkStatusLoading: false,
        updateStatusLoading: false,
        updateKfStatusLoading: false,
        updateLeaderStatusLoading: false,
        itemSwitchList: [],
        clerkItemSwitchIds: [],
        allowRandomOrderSwitch: null,
        clerkWarning: false,
        isResigned: false
      }
    },
    methods: {
      updateRandomOrderSwitch(randomOrderSwitch) {
        updateRandomOrderSwitch(randomOrderSwitch).then(res => {
          const data = res.data;
          if (data.code == 0) {
            Toast('修改成功')
            this.loadData()
          } else {
            Dialog.alert({
              title: '修改失败',
              message: data.msg
            }).then(() => {
              // this.loadData()
            })
          }
        })
      },
      hasRole(role) {
        if (this.roles == null) {
          return false;
        }
        return this.roles.indexOf(role) != -1;
      },
      verifyRole(){
        if (this.roles == null || this.roles.length == 0) {
          this.clerkWarning = true
        }
        if (this.roles.length == 1 && this.hasRole('user')) {
          // 这里是限制只是店员角色 但是已经离职了 就显示离职提示
          if (this.$store.state.isResigned) {
            this.isResigned = true
          } else {
            this.$router.replace('/noAccount')
          }
        }
      },
      loadData() {
        // 获取用户角色
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getUserRoles().then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.roles = data.roles;
            this.verifyRole()
            if (this.hasRole('clerk')) {
              this.loadClerkInfo()
            }
            if (this.hasRole('kf')) {
              this.loadKfInfo()
            }
            if (this.hasRole('leader')) {
              this.loadLeaderInfo()
            }
          } else {
            Dialog.alert({
              title: '获取用户角色失败',
              message: data.msg
            })
          }
        })
      },
      loadKfInfo(){
        getKf().then(res=>{
          const data = res.data;
          if (data.code != 0) {
            Dialog.alert({
              title: '加载客服信息失败',
              desc: data.msg
            })
          }
          this.kf = data.kf
        })
      },
      loadLeaderInfo(){
        getLeader().then(res=>{
          const data = res.data;
          if(data.code!==0){
            Dialog.alert({
              title: '加载组长信息失败',
              desc: data.msg
            })
          }
          this.leader = data.leader
        })
      },
      loadClerkInfo() {
        Promise.all([ getClerk(), getItemSwitchList(),getClerkSetting() ]).then((results) => {

          const data1 = results[0].data
          const data2 = results[1].data
          const data3 = results[2].data
          if (data1.code != 0) {
            Dialog.alert({
              title: '加载' + this.$store.state.label.clerkLabel + '信息失败',
              desc: data1.msg
            })
          }
          if (data2.code != 0) {
            Dialog.alert({
              title: '加载服务失败',
              message: data2.msg
            })
          }

          this.clerk = data1.clerk
          this.clerkIsAutoOnline = this.clerk.isAutoOnline
          this.itemSwitchList = data2.itemSwitchList
          this.clerkItemSwitchIds = data2.clerkItemSwitchIds
          this.allowRandomOrderSwitch = data3.setting.allowRandomOrderSwitch
        }).catch((e) => {
          Dialog.alert({
            title: '加载数据失败',
            message: JSON.stringify(e)
          })
        })
      },
      updateClerkIsAutoOnline(){
        updateClerkAutoOnlineStatus(this.clerkIsAutoOnline).then(res=>{
          const data = res.data;
          if(data.code==0){
            Toast("修改成功")
          }else{
            this.clerkIsAutoOnline = false
            Dialog.alert({
              title: '修改失败',
              message: data.msg
            })
          }
        })
      },
      updateStatus(status,role) {
        let updateAutoOnline = false;
        switch (role){
          case 'clerk':
            this.updateClerkStatusLoading = true
            if(this.$hasFeature('auto_online')){
              updateAutoOnline = true
            }
            updateClerkStatus(status,updateAutoOnline).then(res => {
              this.updateClerkStatusLoading = false
              const data = res.data;
              if (data.code == 0) {
                if(data.msg){
                  Toast(data.msg)
                }else{
                  Toast('修改状态成功')
                }
              } else {
                Dialog.alert({
                  title: '修改状态失败',
                  message: data.msg
                })
              }
              this.loadClerkInfo()
            });
            break;
          case 'kf':
            this.updateKfStatusLoading = true;
            updateKfStatus(status).then(res=>{
              this.updateKfStatusLoading = false
              const data = res.data;
              if (data.code == 0) {
                this.kf.status = status
                Toast('修改状态成功')
              } else {
                this.loadData()
                Dialog.alert({
                  title: '修改状态失败',
                  message: data.msg
                })
              }
            });
            break;
          case 'leader':
            this.updateLeaderStatusLoading = true;
            updateLeaderStatus(status).then(res=>{
              this.updateLeaderStatusLoading = false
              const data = res.data;
              if (data.code == 0) {
                this.leader.status = status
                Toast('修改状态成功')
              } else {
                // this.loadData()
                Dialog.alert({
                  title: '修改状态失败',
                  message: data.msg
                })
              }
            });
            break;
        }

      },
      updateItemSwitch(switchId) {
        let switchIds = [].concat(this.clerkItemSwitchIds)
        if (switchIds.indexOf(switchId) != -1) {
          switchIds.splice(switchIds.indexOf(switchId), 1)
        } else {
          switchIds.push(switchId)
        }

        Toast.loading({
          mask: true,
          message: '请稍候'
        })
        updateItemSwitch(
          JSON.stringify(switchIds),
            switchId
        ).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.clerkItemSwitchIds = switchIds
            Toast('修改成功')
          } else {
            // this.loadData()
            Dialog.alert({
              title: '修改失败',
              message: data.msg
            })
          }
        })
      }
    },
    mounted() {
      this.loadData()
    }
  }
</script>

<style lang="less" scoped>
/deep/.header-custom{
  padding: 20px 20px 0;
  background: none;
}
    .page {
        width: 100%;
        min-height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        padding-bottom: 100px;
        background: url("/static/images/37/bj.png") no-repeat;
        background-size: 100% auto;
    }
    .workbench{
      margin: 50px 20px;
      padding-bottom: 20px;
      background: white;
      border-radius: 15px;
      box-shadow: 0px 4px 8px 0px rgba(83, 179, 193, 0.16);
    }
    .switch-name{
      color: #36A5B6;
    }
  .van-cell-group__title {
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      line-height: 20px;
  }

  .van-cell-group {
    &::after {
        display: none;
    }
  }

  .grid {

    .item {
      display: block;
      padding: 20px 0;
      text-align: center;

      &:active {
        background: #e5e5e5;
      }

      .icon {

      }

      .text {
        color: #333;
        font-size: 12px;
        margin-top: 6px;
      }

    }

  }

    .clerk-status {
      position: absolute;
      right: 0;
      bottom: -5px;
      display: flex;
      align-items: center;
    }

    .item-switch {
        padding: 15px;
        .switch-wrap {
            margin-bottom: 10px;
            display: flex;
        }
        .item-name {
          font-size: 14px;
          font-weight: 600;
          margin-right: 5px;
        }
    }

</style>
